import { Popconfirm, PopconfirmProps, Space } from 'antd';
import {
  DeleteOutlined
} from '@ant-design/icons';

interface DeleteDeviceButtonProps {
  uuid: string;
  onDeleteDevice: (id: string) => void;
}

const DeleteDeviceButton = ({ uuid, onDeleteDevice }: DeleteDeviceButtonProps) => {
  const confirm: PopconfirmProps['onConfirm'] = () => {
    onDeleteDevice(uuid);
  };

  return (
    <Space
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <Popconfirm
        title="Eliminar dispositivo"
        description="¿Estás seguro de que deseas eliminar este dispositivo?"
        onConfirm={confirm}
        okText="Sí"
        cancelText="No"
        placement={'rightTop'}
      >
        <DeleteOutlined/>
      </Popconfirm>
    </Space>
  );
};

export default DeleteDeviceButton;